import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

export const initArticleWSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".article-w-slider__swiper"
  );

  if (sliders.length === 0) {
    return;
  }

  sliders.forEach((sliderElement) => {
    // Destroy existing instance if present (prevents double initialization issues)
    if ((sliderElement as any).swiper) {
      (sliderElement as any).swiper.destroy(true, true);
    }

    new Swiper(sliderElement, {
      modules: [Autoplay, EffectFade],
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000, // Smooth transition duration
      autoplay: {
        delay: 3000, // 3 seconds per slide
        // Enable pausing autoplay when user swipes manually
        disableOnInteraction: true,
      },
      // Ensure it renders correctly even if hidden initially
      observer: true,
      observeParents: true,

      // Enable swiping/dragging logic
      allowTouchMove: true,
      // Show hand cursor to indicate interactivity
      grabCursor: true,
    });
  });

  console.log("[Slider] Article W Slider initialized.");
};
